<div class="progress">
  <div class="progress-bar" role="progressbar" aria-valuenow="25" aria-valuemin="0" aria-valuemax="100"
    [style.height]="getHeight" [style.width]="getWidth"></div>
</div>